import React from 'react';
import { Button } from '../ui/button';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Progress } from '../ui/progress';
import { Ship, ChevronRight, PlayCircle } from 'lucide-react';
import { chapterLabel } from '../../utils/chapterLabel';

const OdysseyCard = ({ odysseeData, user, onNavigate }) => {
  if (!odysseeData) return null;
  
  const { current_chapter, current_milestone, percentage, completed_chapters, total_chapters } = odysseeData;
  
  return (
    <Card className="card-premium border-primary/20 relative overflow-hidden">
      <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-bl from-primary/10 to-transparent rounded-bl-full" />
      <CardHeader className="pb-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="p-2 rounded-xl bg-gradient-to-br from-primary/30 to-primary/10 gold-glow">
              <Ship className="w-5 h-5 text-primary" />
            </div>
            <div>
              <CardTitle className="text-base">Mon Odyssée</CardTitle>
              <CardDescription className="text-xs">
                {completed_chapters || 0}/{total_chapters || 0} chapitres complétés
              </CardDescription>
            </div>
          </div>
          <Button 
            variant="outline" 
            size="sm" 
            onClick={() => onNavigate('/progression')} 
            className="hover-lift border-primary/30 text-primary hover:bg-primary/10"
            data-testid="odyssey-btn"
          >
            Continuer <ChevronRight className="w-4 h-4 ml-1" />
          </Button>
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        {/* Progress bar */}
        <div>
          <div className="flex justify-between text-xs text-muted-foreground mb-2">
            <span>Progression globale</span>
            <span className="text-primary font-medium">{percentage || 0}%</span>
          </div>
          <Progress value={percentage || 0} className="h-2" />
        </div>
        
        {/* Current position */}
        {current_chapter && (
          <div className="p-3 bg-secondary/30 rounded-lg border border-border/50">
            <p className="text-xs text-muted-foreground mb-1">Chapitre en cours</p>
            <p className="font-medium text-sm break-words">{chapterLabel(current_chapter)}</p>
            {current_milestone && (
              <p className="text-xs text-muted-foreground mt-2">
                → Prochain jalon : {current_milestone.title}
              </p>
            )}
            {current_chapter.lesson_url && (
              <Button
                size="sm"
                className="mt-3 w-full bg-primary text-primary-foreground hover:bg-primary/90"
                onClick={() => window.open(current_chapter.lesson_url, '_blank', 'noopener')}
                data-testid="resume-formation-btn"
              >
                <PlayCircle className="w-4 h-4 mr-2" />
                Reprendre ma formation
              </Button>
            )}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default OdysseyCard;
